var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"typewriter"},[_c('h3',[_vm._v(" I am a "),_c('span',{attrs:{"id":"txt-rotate"}})])])}]

export { render, staticRenderFns }